import {Boost} from '@/domain/models/Boost';
import {boostStore} from '@/entities/boost';

export function boostMeHandler(boost: Boost) {
  boostStore.setMyBoost(boost);
}
